import { render, staticRenderFns } from "./FreddiesAddons.vue?vue&type=template&id=64ec7b98&scoped=true&"
import script from "./FreddiesAddons.vue?vue&type=script&lang=js&"
export * from "./FreddiesAddons.vue?vue&type=script&lang=js&"
import style0 from "./FreddiesAddons.vue?vue&type=style&index=0&id=64ec7b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec7b98",
  null
  
)

export default component.exports